export const STANDARD_DATE_FORMAT = `MM/DD/YYYY`;
export const USER_DATE_FORMAT = 'MMM DD, YYYY';
export const METRICS_DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_DATE_FORMAT = 'MMM DD, YYYY hh:mm:ss A';
export const DISPLAY_DATE_FORMAT = 'MMM DD YYYY';
export const SUPPORTED_DATE_FORMATS = [
  STANDARD_DATE_FORMAT,
  USER_DATE_FORMAT,
  METRICS_DATE_FORMAT,
  TIME_DATE_FORMAT,
  DISPLAY_DATE_FORMAT,
];
